import * as React from "react";
const SvgFolderLine = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9.555 4.168A1 1 0 0 0 9 4H3a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V7l-.007-.117A1 1 0 0 0 21 6h-8.697zM4 6h4.697l2.748 1.832.102.06A1 1 0 0 0 12 8h8v10H4z", clipRule: "evenodd" }));
export default SvgFolderLine;
